<div class="add-edit-integration-component">
  <div class="ws-popup-header">
    <div class="integration-header">
      <div>
        <img
          [src]="integration.integration?.imageUrl"
          class="mediumImage"
          mat-card-lg-image
          style="width: unset; height: unset"
        />
      </div>
    </div>
    <div class="actions">
      <button mat-icon-button (click)="closeClicked()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="ws-popup-content">
    <div class="integration-create">
      <mat-horizontal-stepper>
        <mat-step>
          <div *ngIf="!isEdit">
            <div style="font-size: 14px">
              <div style="font-size: 20px">
                {{ integration.integration?.name }}
              </div>
              <ng-container *ngIf="!dynamicComponent">
                <p style="font-weight: 300">
                  {{ "Inserisci qui sotto i dati forniti da " | translate }}
                  {{ integration.integration?.name }}
                </p>
              </ng-container>
            </div>
          </div>

          <ng-container *ngIf="integration.multiAccount; else defaultWrapper">
            <mat-accordion>
              <ng-container *ngFor="let group of form.controls; index as i">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div style="display: flex; gap: 2rem;">
                        <span>
                          {{ (wineryIntegration?.integrationData.array || [])[i]?.name || ("Add" | translate) }}
                        </span>
                        <span *ngIf="integration.integrationType === 'EXTERNAL_CALENDAR' && (wineryIntegration?.integrationData.array || [])[i]?.email">
                          {{ (wineryIntegration?.integrationData.array || [])[i]?.email }}
                        </span>
                      </div>
                    </mat-panel-title>

                    <mat-panel-description
                      style="justify-content: flex-end; gap: 5px"
                    >
                      <mat-icon
                        (click)="actionClicked($event, i, 'connect')"
                        *ngIf="
                          dynamicComponent &&
                          getIsActionButtonVisible('connect', i)
                        "
                        [wsTooltip]="'Connect' | translate"
                        >add
                      </mat-icon>
                      <mat-icon
                        (click)="actionClicked($event, i, 'sync')"
                        *ngIf="
                          dynamicComponent &&
                          getIsActionButtonVisible('sync', i)
                        "
                        [wsTooltip]="'Sync' | translate"
                        >sync</mat-icon
                      >
                      <mat-icon
                        [wsTooltip]="'Delete' | translate"
                        (click)="actionClicked($event, i, 'remove')"
                        *ngIf="
                          dynamicComponent &&
                          getIsActionButtonVisible('remove', i)
                        "
                        style="color: red"
                        >delete</mat-icon
                      >
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <ng-container
                    *ngTemplateOutlet="
                      contentTemplate;
                      context: { index: i, group: group }
                    "
                  ></ng-container>
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>
          </ng-container>

          <ng-template #defaultWrapper>
            <ng-container
              *ngTemplateOutlet="
                contentTemplate;
                context: { index: 0, group: form.at(0) }
              "
            ></ng-container>
          </ng-template>
        </mat-step>
        <mat-step>
          <div [innerHTML]="finishMessage | translate"></div>
        </mat-step>
      </mat-horizontal-stepper>
    </div>

    <ng-container
      *ngTemplateOutlet="
        bottomActionButtonsTemplate;
        context: { visible: !dynamicComponent && !integration.multiAccount }
      "
    ></ng-container>
  </div>
  <ng-template #contentTemplate let-group="group" let-index="index">
    <div
      *ngFor="let control of objectKeysWithoutFragments(group.controls)"
      class="field-wrapper"
    >
      <label for="name">
        {{ bestName(control) | translate }}
      </label>
      <input
        [formControl]="group.get(control)"
        [type]="getRegistryType(control)"
        id="control"
        matInput
      />
    </div>
  
    <ng-container
      *ngTemplateOutlet="
        bottomActionButtonsTemplate;
        context: {
          visible: !dynamicComponent && integration.multiAccount,
          index: index
        }
      "
    ></ng-container>
  
    <ng-container *ngIf="dynamicComponent">
      <ng-container
        *ngComponentOutlet="dynamicComponent; injector: fragmentInjectors[index]"
      ></ng-container>
    </ng-container>
  </ng-template>
  
  <ng-template
    #bottomActionButtonsTemplate
    let-index="index"
    let-visible="visible"
  >
    <div *ngIf="visible" class="ws-popup-footer">
      <ws-button
        (click)="saveClicked(index)"
        *ngIf="getIsActionButtonVisible('connect', index)"
        callToActionType="primary"
      >
        {{ "Save" | translate }}
      </ws-button>
      <ws-button
        (click)="syncClicked(index)"
        *ngIf="
          isEdit &&
          integration.syncEnabled &&
          getIsActionButtonVisible('sync', index)
        "
        callToActionType="tertiary"
      >
        {{ "Sync" | translate }}
      </ws-button>
      <ws-button
        (click)="removeClicked(index)"
        *ngIf="isEdit && getIsActionButtonVisible('remove', index)"
        callToActionType="danger"
      >
        {{ "Remove" | translate }}
      </ws-button>
    </div>
  </ng-template>
</div>

<!-- -- Templates -- -->
